<style scoped>
  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    top: 5px;
  }
</style>

<template>
  <div>
    <m-assembly-table ref="pageForm"
                      :formData="formData"
                      :columns="columns"
                      :data="data"
                      :total="total"
                      :settings="settings"
                      :tableButtons="tableButtons"
                      :loading="loading"
                      :currentPage="myPage"
                      :pageSize="myPageSize"
                      @onSubmit="mySubmit"
                      @onPageSizeChange="onPageSizeChange"
                      @onCurrentPageChange="onCurrentPageChange"
                      @onRowClick="onRowClick"
                      @onView="onView"
                      @onEdit="onEdit"
                      @onDelete="onDelete"
                      @onSelect="onSelect"
                      @onSelectAll="onSelectAll"
                      thDrag

    ></m-assembly-table>
    <Modal v-model="addEditFlg"
           :title="sysOrganValidate.organizationId === '' ? '新增' : '编辑'"
           class-name="vertical-center-modal"
           :mask-closable="false"
           :styles="{top:'30px'} " width="850">
      <Form ref="sysOrganRef" :model="sysOrganValidate" :rules="ruleValidate"
            :label-width="120">
        <Row>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.ORGANIZATION_TYPE')" prop="organizationType">
            <Select v-model="sysOrganValidate.organizationType" placeholder="请选择组织类型"
                    @on-change="togFatherOrgs" filterable>
              <Option v-for="item in organTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.ORGANIZATION_CODE')" prop="organizationCode">
            <Input v-model="sysOrganValidate.organizationCode"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.NAME_ZHS')" prop="nameZhs">
            <Input v-model="sysOrganValidate.nameZhs"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.NAME_US')" prop="nameUs">
            <Input v-model="sysOrganValidate.nameUs"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.NAME_JP')" prop="nameJp">
            <Input v-model="sysOrganValidate.nameJp"></Input>
          </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="this.$t('sysOrganizationsQueryTable.ATTRIBUTE4')" prop="attribute4">
              <Select v-model="sysOrganValidate.attribute4" disabled>
                <Option value="Y">是</Option>
                <Option value="N">否</Option>
              </Select>
            </FormItem>
            </Col>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.PA_NAME_ZHS')" prop="parentOrganizationId">
            <Select v-model="sysOrganValidate.parentOrganizationId" placeholder="请选择父组织"
                    :disabled="!sysOrganValidate.attribute4"
                    filterable>
              <Option v-for="organ in fatherOrgs" :value="organ.ORGANIZATION_ID"
                      :key="organ.ORGANIZATION_ID">{{ organ.NAME_ZHS }}
              </Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.START_DATE')" prop="startDate">
            <MDatePicker v-model="sysOrganValidate.startDate" type="date"
                         @on-change="selStartDate" @on-clear="clearStartDate"></MDatePicker>
            <!--<DatePicker type="date" placeholder="请选择" v-model="sysOrganValidate.startDate"-->
                        <!--@on-change="sysOrganValidate.startDate=$event"></DatePicker>-->
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.END_DATE')" prop="endDate">
            <MDatePicker v-model="sysOrganValidate.endDate" type="date"
                         @on-change="selEndDate" @on-clear="clearEndDate"></MDatePicker>
            <!--<DatePicker type="date" placeholder="请选择" v-model="sysOrganValidate.endDate"-->
                        <!--@on-change="sysOrganValidate.endDate=$event"></DatePicker>-->
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.SRM_ID')" prop="srmId">
            <Input v-model="sysOrganValidate.srmId"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.ERP_ID')" prop="erpId">
            <Input v-model="sysOrganValidate.erpId"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.SCP_ID')" prop="scpId">
            <Input v-model="sysOrganValidate.scpId"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.QMS_ID')" prop="qmsId">
            <Input v-model="sysOrganValidate.qmsId"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.MES_ID')" prop="mesId">
            <Input v-model="sysOrganValidate.mesId"></Input>
          </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="送货单抬头" prop="shortNameZhs">
              <Input v-model="sysOrganValidate.shortNameZhs"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.IERP_ID')" prop="attribute7">
            <Input v-model="sysOrganValidate.attribute7"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem :label="this.$t('sysOrganizationsQueryTable.ATTRIBUTE3')" prop="attribute3">
            <Input v-model="sysOrganValidate.attribute3"></Input>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer" style="text-align: center;">
        <Button type="primary" @click="save('sysOrganRef')">{{$t('sysOrganizationsQueryTable.BTN_SAVE')}}</Button>
        <Button type="ghost" @click="reset('sysOrganRef')"
                style="margin-left: 8px">{{$t('sysOrganizationsQueryTable.BTN_RESET')}}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/datetime-format';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import axios from 'axios';
import { exportExcel } from '@/utils/tool';

export default {
    name: 'sysOrgsTable',
    components: {
        mAssemblyTable,
    },
    data() {
        return {
            loading: false,
            myPage: 1,
            myPageSize: 10,
            organTypes: [],
            fatherOrgs: [],
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgName',
                        validators: {
                            type: {
                                type: 'string',
                                message: 'sysOrganizationsQueryTable.textItem',
                            },
                            length: {
                                min: 1,
                                max: 100,
                                message: 'sysOrganizationsQueryTable.length',
                            },
                        },
                        disabled: false,
                        placeholder: '组织名称',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: '组织名称',
                    },
                    {
                        value: '',
                        field: 'orgId',
                        validators: {
                            type: {
                                type: 'string',
                                message: 'sysOrganizationsQueryTable.textItem',
                            },
                            length: {
                                min: 1,
                                max: 100,
                                message: 'sysOrganizationsQueryTable.length',
                            },
                        },
                        disabled: false,
                        placeholder: '组织ID',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: '组织ID',
                    },
                ],
                buttons: {
                    showSubmit: true,
                    submitText: this.$t('sysOrganizationsQueryTable.submitText'),
                    showReset: true,
                    showSearch: true,
                    layout: {
                        span: 24,
                        push: 8,
                    },
                },
            },
            columns: {
                showCheckbox: false,
                showButtons: true,
                columns: [
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.ORGANIZATION_TYPE'));
                        },
                        render: (h, params) => {
                            let value = this.orgTypeNameConv(params.row.ORGANIZATION_TYPE);
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'ORGANIZATION_TYPE',
                        align: 'center',
                        width: 100,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.ORGANIZATION_CODE'));
                        },
                        render: (h, params) => {
                            let value = params.row.ORGANIZATION_CODE;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'ORGANIZATION_CODE',
                        align: 'center',
                        width: 100,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.NAME_ZHS'));
                        },
                        render: (h, params) => {
                            let value = params.row.NAME_ZHS;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'NAME_ZHS',
                        align: 'center',
                        width: 250,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.NAME_US'));
                        },
                        render: (h, params) => {
                            let value = params.row.NAME_US;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'NAME_US',
                        align: 'center',
                        width: 160
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.NAME_JP'));
                        },
                        render: (h, params) => {
                            let value = params.row.NAME_JP;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'NAME_JP',
                        align: 'center',
                        width: 160,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.PA_NAME_ZHS'));
                        },
                        render: (h, params) => {
                            let value = params.row.PA_NAME_ZHS;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'PA_NAME_ZHS',
                        align: 'center',
                        width: 250,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.SRM_ID'));
                        },
                        render: (h, params) => {
                            let value = params.row.SRM_ID;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'SRM_ID',
                        align: 'center',
                        width: 90
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.ERP_ID'));
                        },
                        render: (h, params) => {
                            let value = params.row.ERP_ID;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'ERP_ID',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.SCP_ID'));
                        },
                        render: (h, params) => {
                            let value = params.row.SCP_ID;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'SCP_ID',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.QMS_ID'));
                        },
                        render: (h, params) => {
                            let value = params.row.QMS_ID;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'QMS_ID',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.MES_ID'));
                        },
                        render: (h, params) => {
                            let value = params.row.MES_ID;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'MES_ID',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.ATTRIBUTE1'));
                        },
                        render: (h, params) => {
                            let value = params.row.ATTRIBUTE1;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'ATTRIBUTE1',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.IERP_ID'));
                        },
                        render: (h, params) => {
                            let value = params.row.ATTRIBUTE7;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'ATTRIBUTE7',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.ATTRIBUTE3'));
                        },
                        render: (h, params) => {
                            let value = params.row.ATTRIBUTE3;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'ATTRIBUTE3',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.ATTRIBUTE4'));
                        },
                        render: (h, params) => {
                            let value = params.row.ATTRIBUTE4;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', value === 'Y' ? '是' : (value === 'N' ? '否' : '-'));
                        },
                        key: 'ATTRIBUTE4',
                        align: 'center',
                        width: 90,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.START_DATE'));
                        },
                        render: (h, params) => {
                            let value = params.row.START_DATE;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'START_DATE',
                        align: 'center',
                        width: 110,
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('span', this.$t('sysOrganizationsQueryTable.END_DATE'));
                        },
                        render: (h, params) => {
                            let value = params.row.END_DATE;
                            if (value === undefined || value.length < 1) {
                                value = '-';
                            }
                            return h('span', this.$t(value));
                        },
                        key: 'END_DATE',
                        align: 'center',
                        width: 110,
                    },
                ],
                buttons: {
                    edit: { icon: true, label: false },
                    // delete: true,
                    columnWidth: 90,
                },
            },
            data: [],
            total: 0,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true,
            },
            addEditFlg: false,
            sysOrganValidate: {
                organizationId: '',
                organizationType: '',
                organizationCode: '',
                nameZhs: '',
                nameUs: '',
                nameJp: '',
                parentOrganizationId: '',
                srmId: '',
                erpId: '',
                scpId: '',
                qmsId: '',
                mesId: '',
                attribute7: '',
                attribute3: '',
                attribute4: '',
                startDate: '',
                endDate: '',
                shortNameZhs: '',
            },
            ruleValidate: {
                organizationType: [
                    {required: true, message: this.$t('sysOrganizationsQueryTable.ORGANIZATION_TYPE') + '不能空', trigger: 'blur'}
                ],
                nameZhs: [
                    {required: true, message: this.$t('sysOrganizationsQueryTable.NAME_ZHS') + '不能为空', trigger: 'blur'},
                    {
                        type: 'string',
                        max: 240,
                        message: this.$t('sysOrganizationsQueryTable.NAME_ZHS') + '不能超过240个字符',
                        trigger: 'blur'
                    }
                ],
                nameUs: [
                    {
                        type: 'string',
                        max: 240,
                        message: this.$t('sysOrganizationsQueryTable.NAME_US') + '不能超过240个字符',
                        trigger: 'blur'
                    }
                ],
                nameJp: [
                    {
                        type: 'string',
                        max: 240,
                        message: this.$t('sysOrganizationsQueryTable.NAME_JP') + '不能超过240个字符',
                        trigger: 'blur'
                    }
                ],
                parentOrganizationId: [
                    {required: false, message: '请选择' + this.$t('sysOrganizationsQueryTable.PA_NAME_ZHS'), trigger: 'blur'}
                ],
                startDate: [
                    {
                        required: true,
                        type: 'date',
                        message: '请选择' + this.$t('sysOrganizationsQueryTable.START_DATE'),
                        trigger: 'change'
                    }
                ],
                srmId: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.SRM_ID') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                erpId: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.ERP_ID') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                scpId: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.SCP_ID') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                qmsId: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.QMS_ID') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                mesId: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.MES_ID') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                attribute1: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.ATTRIBUTE1') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                attribute7: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.IERP_ID') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                attribute3: [
                    {
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.ATTRIBUTE3') + '不能超过40个字符',
                        trigger: 'blur'
                    }
                ],
                attribute4: [
                    {
                        required: true,
                        type: 'string',
                        max: 40,
                        message: this.$t('sysOrganizationsQueryTable.ATTRIBUTE4') + '不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            tableButtons: {
                customButtons: [
                    {
                        name: 'btn-add',
                        icon: 'plus',
                        label: this.$t('sysOrganizationsQueryTable.BTN_ADD'),
                        click: () => {
                            let userId = this.curUserInfo.loginName;
                            this.reset('sysOrganRef');
                            this.sysOrganValidate.startDate = this.getCurDate();
                            if (userId !== undefined && parseInt(userId)) {
                                this.sysOrganValidate.createdBy = userId;
                                this.sysOrganValidate.lastUpdatedBy = userId;
                            }
                            this.sysOrganValidate.organizationId = '';
                            this.addEditFlg = true;
                            this.sysOrganValidate.attribute4 = 'Y';
                        }
                    },
                    {
                        name: 'btn-export',
                        icon: 'archive',
                        label: this.$t('sysOrganizationsQueryTable.BTN_EXPORT'),
                        click: (button, e) => {
                            this.export2excel(button, e);
                        }
                    }
                ]
            },
            curUserInfo: {},
        };
    },
    mounted() {
        this.getOrgType();
        this.getUserInfo();
        this.initPageStatus();
    },
    watch: {
        sysOrganValidate: function (val) {
            this.togFatherOrgs(val);
        }
    },
    methods: {
        selStartDate(event) {
            if (event) {
                this.sysOrganValidate.startDate = new Date(event);
            }
            this.$refs['sysOrganRef'].validateField('startDate', (valid) => {
            });
        },
        clearStartDate() {
            this.sysOrganValidate.startDate = '';
        },
        selEndDate(event) {
            if (event) {
                this.sysOrganValidate.endDate = new Date(event);
            }
            this.$refs['sysOrganRef'].validateField('endDate', (valid) => {
            });
        },
        clearEndDate() {
            this.sysOrganValidate.endDate = '';
        },
        mySubmit() {
            this.myPage = 1;
            this.onSubmit(this.myPage, this.myPageSize, {});
        },
        onSubmit(page, pageSize, condition) {
            this.loading = true;
            let queryParam = {};
            let queryForm = new FormData();
            queryParam.page = page;
            queryParam.pageSize = pageSize;
            // queryParam.orgName = condition.orgName;
            // queryParam.orgId = condition.orgId;
            this.formData.items.forEach(
                item => {
                    if (item.value) {
                        let obj = {};
                        if (typeof item.value === 'boolean') {
                            if (item.value) {
                                obj.value = '0';
                            }
                        } else if (item.value instanceof Date) {
                            obj.value = formatDateTime(item.value, 'yyyy-MM-dd');
                        } else {
                            obj.value = item.value.toString().trim();
                        }
                        queryParam[item.field] = obj.value;
                    }
                }
            );
            queryForm.append('queryJson', JSON.stringify(queryParam));
            axios.post('/gscint/sys/sysOrganizations/getSysOrganizations', queryForm).then(
                res => {
                    this.data = res.data.data.list;
                    this.total = res.data.data.total;
                    this.loading = false;
                }
            )
                .catch(() => {
                    this.showErrorTips();
                });
        },
        // 页容量改变时触发
        onPageSizeChange(page, pageSize, condition) {
            this.myPage = page;
            this.myPageSize = pageSize;
            this.onSubmit(page, pageSize, condition);
        },
        // 当前页改变时触发
        onCurrentPageChange(page, pageSize, condition) {
            this.myPage = page;
            this.myPageSize = pageSize;
            this.onSubmit(page, pageSize, condition);
        },
        /** 初始化页面状态 */
        initPageStatus() {
            this.mySubmit();
        },
        onView(row, column, index) {
        },
        onEdit(row, column, index) {
            let me = this;
            me.reset('sysOrganRef');
            let queryData = new FormData();
            queryData.append('id', row.ORGANIZATION_ID);
            /* 增加ATTRIBUTE4字段 */
            queryData.append('attribute4', row.ATTRIBUTE4 || '');
            axios.post('/gscint/sys/sysOrganizations/selectById', queryData).then(
                res => {
                    me.shallowClone(res.data.data, me.sysOrganValidate);
                    me.addEditFlg = true;
                    // this.formatFormData();
                }
            ).catch(() => (
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('resultJson.msg')
                })
            ));
        },
        onDelete(row, column, index) {
        },
        onRowClick(row, index) {
        },
        onSelect(selection, row) {
        },
        onSelectAll(selection) {
        },
        getOrg() {
            axios.get('/gscint/lov/getSRMInvLovList').then(res => (
                this.formData.items[0].options.values = res.data.data
            )).catch(() => (
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('resultJson.msg')
                })
            ));
        },
        getOrgType() {
            axios.get('/gscint/sys/sysParam/queryDictionaryData?dictCode=ORGANIZATION_TYPE').then(
                res => {
                    this.organTypes = res.data.data;
                }
            ).catch(() => (
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('resultJson.msg')
                })
            ));
        },
        orgTypeNameConv(value) {
            let typeName = '';
            for (let i = 0; i < this.organTypes.length; i++) {
                let obj = this.organTypes[i];
                if (value === obj.value) {
                    typeName = obj.label;
                    break;
                }
            }
            return typeName;
        },
        save(name) {
            let me = this;
            me.$refs[name].validate((valid) => {
                if (valid) {
                    me.$Modal.confirm({
                        title: me.$t('sysOrganizationsQueryTable.ALERT_TITLE'),
                        content: me.$t('sysOrganizationsQueryTable.POPTIP'),
                        onOk: () => {
                            setTimeout(() => {
                                let formData = new FormData();
                                let jsonStr = JSON.stringify(me.sysOrganValidate);
                                formData.append('formJson', jsonStr);
                                axios.post('/gscint/sys/sysOrganizations/saveOrUpdate', formData).then(
                                    res => {
                                        if (res.data.data && res.data.data.resultCode === 'success') {
                                            me.addEditFlg = false;
                                            me.instance('success');
                                            me.reset('sysOrganRef');
                                            me.onSubmit(1, 10, {});
                                        } else {
                                            me.$Modal.error({
                                                title: me.$t('common.warn'),
                                                content: res.data.data.resultMessage || me.$t('resultJson.msg')
                                            });
                                            return;
                                        }
                                    }
                                ).catch(
                                    () => {
                                        me.$Modal.error({
                                            title: me.$t('common.warn'),
                                            content: me.$t('resultJson.msg')
                                        });
                                        return;
                                    }
                                );
                            }, 400)
                        },
                        onCancel: () => {
                        }
                    });
                } else {
                    return;
                }
            });
        },
        reset(name) {
            this.$refs[name].resetFields();
        },
        instance (type) {
            const title = this.$t('sysOrganizationsQueryTable.ALERT_TITLE');
            switch (type) {
                case 'success':
                this.$Modal.success({
                    title: title,
                    content: this.$t('sysOrganizationsQueryTable.EXC_SUCC')
                });
                break;
            case 'error':
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('resultJson.msg')
                });
                break;
            }
        },
        togFatherOrgs(obj) {
            let orgType = this.sysOrganValidate.organizationType;
            if (orgType === null || orgType === '') {
                return;
            }
            if (orgType !== 'GC') {
                this.ruleValidate.parentOrganizationId.required = true;
            } else {
                this.ruleValidate.parentOrganizationId.required = false;
            }
            this.$refs['sysOrganRef'].rules = this.ruleValidate;
            let queryData = new FormData();
            queryData.append('orgType', orgType);
            axios.post('/gscint/sys/sysOrganizations/getFatherOrgs', queryData).then(
                res => {
                    this.fatherOrgs = res.data.data;
                }
            ).catch(
                () => (
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('resultJson.msg')
                    })
                )
            );
        },
        getCurDate() {
            // let presDate = new Date();// 当前日期
            // let fullYear = presDate.getFullYear();
            // let curMonth = presDate.getMonth() + 1;
            // let date = presDate.getDate();
            // return fullYear + '-' + (curMonth < 10 ? '0' + curMonth : curMonth) + '-' + date;
            return new Date();// 当前日期
        },
        getUserInfo() { // 获取当前用户的信息
            // axios.get('/gscint/vendor/getCurrentVendor').then(res => {
            //     this.curUserInfo = res.data.data;
            // }).catch(() => (
            //     this.$Modal.error({
            //         title: this.$t('common.warn'),
            //         content: this.$t('resultJson.msg')
            //     })
            // ));
            this.curUserInfo = JSON.parse(localStorage.getItem('user')) || {};
        },
        /** 导出Excel */
        export2excel(button, e) {
            this.$set(button, 'loading', true);
            let queryParam = {};
            let queryForm = new FormData();
            queryParam.orgName = this.formData.items[0].value;
            queryParam.orgId = this.formData.items[1].value;
            queryForm.append('queryJson', JSON.stringify(queryParam));
            exportExcel('/gscint/sys/sysOrganizations/exportExcel', queryForm, '组织设置.xlsx', this)
                .finally(() => {
                    this.$set(button, 'loading', false);
                });
        },
        shallowClone(src, des) {
            if (!src || typeof src !== 'object' ||
            !des || typeof des !== 'object') {
                return;
            }
            for (let keys in src) {
                if (src.hasOwnProperty(keys) && des.hasOwnProperty(keys)) {
                    if (keys.toString().toLowerCase().indexOf('date') > -1) {
                        if (src[keys] > 0) {
                            des[keys] = new Date(src[keys]);
                        }
                    } else {
                        des[keys] = src[keys];
                    }
                }
            }
        }
    }
};
</script>
